import EcoSpace from 'eco-design/base/eco-space';
import EcoImg from 'eco-design/base/eco-img';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function Certificate() {
    const { t } = useLang('Certificate');
    return (
        <div className="GtmModuleData-section" data-section-id="Certificate">
            <EcoSpace />
            <div className={styles.Certificate}>
                <EcoImg
                    isOpenLazy
                    pc="https://websiteoss.ecoflow.com/figma-uploads/1758706795474-9v3wsk-compressed-D2M-1200x628.jpg"
                    pad="https://websiteoss.ecoflow.com/figma-uploads/1758706795474-9v3wsk-compressed-D2M-1200x628.jpg"
                    h5="https://websiteoss.ecoflow.com/figma-uploads/1758768784675-n0307l-compressed-D2M-1200x628.jpg"
                />
                <div className="certificate-text eco-content">
                    <h5 className="certificate-label">{t('Certificate_title')}</h5>
                    <h5 className="certificate-title">{t('Certificate_desc')}</h5>
                    <EcoImg
                        isOpenLazy
                        className="certificate-img"
                        pc="https://websiteoss.ecoflow.com/figma-uploads/1758197347883-9pbihr-compressed-Frame%20128720546.png"
                        pad="https://websiteoss.ecoflow.com/figma-uploads/1758197347883-9pbihr-compressed-Frame%20128720546.png"
                        h5="https://websiteoss.ecoflow.com/figma-uploads/1758710502407-iavka8-compressed-Frame%201612708080.png"
                    />
                </div>
            </div>
        </div>
    );
}
